"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casargo": {
    "03eb6368": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "skipSearch": false
    }],
    "codesino": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7830d758": [{
      "hkey": "52bdb8e9",
      "slug": "narro-indovero",
      "name": "Narro-Indovero",
      "primary": true,
      "skipSearch": false
    }],
    "indover": [{
      "hkey": "52bdb8e9",
      "slug": "narro-indovero",
      "name": "Narro-Indovero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casargo"
    }],
    "3414b1e6": [{
      "hkey": "52bdb8e9",
      "slug": "narro-indovero",
      "name": "Narro-Indovero",
      "primary": true,
      "skipSearch": false
    }],
    "narro": [{
      "hkey": "52bdb8e9",
      "slug": "narro-indovero",
      "name": "Narro-Indovero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "19b55665": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "skipSearch": false
    }],
    "piazzo": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbb7d9ec": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "skipSearch": false
    }],
    "somadino": [{
      "hkey": "551083b4",
      "slug": "casargo",
      "name": "Casargo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;